freespinSkipButton = {};

freespinSkipButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);

  button.canEnable = function () {
    let playingAnims = winlineAnimationController.isAnimating;
    return playingAnims && !this._flags.modal.active && this._flags.skipWinPlatformEnabled;
  };

  button.canShow = function () {
    let playingAnims = winlineAnimationController.isAnimating;
    return playingAnims && !this._flags.modal.active && this._flags.skipWinPlatformEnabled;
  };

  button.onPressedCallback = function () {
    winlineAnimationController.skipAnimations();
  };

  return button;
};

freespinSkipButton.initialise = function (json, object) {};
freespinSkipButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'freespinSkipButton',
  freespinSkipButton.create,
  freespinSkipButton.initialise,
  freespinSkipButton.getFilesRequired
);
